import { render, staticRenderFns } from "./notificationRow.vue?vue&type=template&id=5e4cc2ff&scoped=true"
import script from "./notificationRow.vue?vue&type=script&lang=ts"
export * from "./notificationRow.vue?vue&type=script&lang=ts"
import style0 from "./notificationRow.vue?vue&type=style&index=0&id=5e4cc2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4cc2ff",
  null
  
)

export default component.exports